var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38460_3451)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.875 4.3125C3.42745 4.3125 2.99822 4.49029 2.68176 4.80676C2.36529 5.12323 2.1875 5.55245 2.1875 6C2.1875 6.44755 2.36529 6.87678 2.68176 7.19324C2.99822 7.50971 3.42745 7.6875 3.875 7.6875H5.20297C5.51363 7.6875 5.76547 7.93934 5.76547 8.25C5.76547 8.56066 5.51363 8.8125 5.20297 8.8125H3.875C3.12908 8.8125 2.41371 8.51618 1.88626 7.98874C1.35882 7.46129 1.0625 6.74592 1.0625 6C1.0625 5.25408 1.35882 4.53871 1.88626 4.01126C2.41371 3.48382 3.12908 3.1875 3.875 3.1875H5.17367C5.48433 3.1875 5.73617 3.43934 5.73617 3.75C5.73617 4.06066 5.48433 4.3125 5.17367 4.3125H3.875Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26379 3.75C7.26379 3.43934 7.51563 3.1875 7.82629 3.1875H9.12497C9.87089 3.1875 10.5863 3.48382 11.1137 4.01126C11.6411 4.53871 11.9375 5.25408 11.9375 6C11.9375 6.74592 11.6411 7.46129 11.1137 7.98874C10.5863 8.51618 9.87089 8.8125 9.12497 8.8125H7.797C7.48634 8.8125 7.2345 8.56066 7.2345 8.25C7.2345 7.93934 7.48634 7.6875 7.797 7.6875H9.12497C9.57252 7.6875 10.0017 7.50971 10.3182 7.19324C10.6347 6.87678 10.8125 6.44755 10.8125 6C10.8125 5.55245 10.6347 5.12322 10.3182 4.80676C10.0017 4.49029 9.57252 4.3125 9.12497 4.3125H7.82629C7.51563 4.3125 7.26379 4.06066 7.26379 3.75Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90002 6C3.90002 5.68934 4.15186 5.4375 4.46252 5.4375H8.58424C8.8949 5.4375 9.14674 5.68934 9.14674 6C9.14674 6.31066 8.8949 6.5625 8.58424 6.5625H4.46252C4.15186 6.5625 3.90002 6.31066 3.90002 6Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38460_3451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.90db20589eeb132e1c9aa1a85bc312ac.svg";
export { ForwardRef as ReactComponent };